import React, { createContext, useReducer, useContext } from 'react';
import { findIndex } from 'ramda';

const RootStateContext = createContext();
const RootDispatchContext = createContext();

const initRegistryState = {
  list: [],
  team: null,
};

const registryReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'SET_LIST': {
      return {
        ...state,
        list: payload,
      };
    }
    case 'SET_TEAM': {
      return {
        ...state,
        team: payload,
      };
    }
    case 'UPDATE_TEAM_IN_REGISTRY': {
      const teamInRegistryIndex = findIndex((tir) => tir.uniqid === payload.uniqid, state.list);
      if (teamInRegistryIndex < 0) {
        return state;
      }

      const newList = [...state.list];
      newList[teamInRegistryIndex] = {
        ...newList[teamInRegistryIndex],
        ...payload,
      };

      if (!payload.connected_team) {
        delete newList[teamInRegistryIndex].connected_team;
      }

      return {
        ...state,
        list: newList,
        team: newList[teamInRegistryIndex],
      };
    }
    default:
      throw new Error('Invalid action type');
  }
};

const RegistryProvider = ({ children }) => {
  const [state, dispatch] = useReducer(registryReducer, initRegistryState);

  return (
    <RootStateContext.Provider value={state}>
      <RootDispatchContext.Provider value={dispatch}>{children}</RootDispatchContext.Provider>
    </RootStateContext.Provider>
  );
};

const useRegistryState = () => {
  const context = useContext(RootStateContext);

  if (context === undefined) {
    throw new Error('useRegistryState must be used within a RegistryProvider');
  }
  return context;
};

const useRegistryDispatch = () => {
  const context = useContext(RootDispatchContext);

  if (context === undefined) {
    throw new Error('useRegistryDispatch must be used within a RegistryProvider');
  }
  return context;
};

export { RegistryProvider, useRegistryState, useRegistryDispatch };
